import { Icon, Tooltip } from '@mairistem/composants';
import { Feature, Menu } from '@mairistem/module';
import { MENUS } from '@/constants';
import { showTooltips } from '@/utils';
import RecusMenu from '../RecusMenu/RecusMenu';

/**
 * MenuRecus
 *
 * Point de menu "Reçus" de 1er niveau, affiché en régie autonome à la place du dépliable
 * "Cycles, factures et reçus". Sa visibilité est décidée a posteriori par MenuVisibility selon la
 * régie (le framework fige les menus au premier render, donc les deux menus sont toujours rendus).
 * Route /recus distincte de /listes/recus pour un ciblage sans ambiguïté par le masquage.
 */
const MenuRecus = () => (
  <Menu
    code={MENUS.MENU_RECUS_AUTONOME}
    name="Reçus"
    icon={
      showTooltips ? (
        <Tooltip trigger={<Icon name="list" />} message="Reçus" position="right center" />
      ) : (
        <Icon name="list" />
      )
    }
    path="/recus"
  >
    <Feature>
      <Feature.Content>
        <RecusMenu />
      </Feature.Content>
    </Feature>
  </Menu>
);

export default MenuRecus;
